import { ButtonProps } from "../../../../types"
import Button from "../button"

const BtnDanger = ({ children, className = "", ...rest }: ButtonProps) => (
  <Button
    {...rest}
    className={`${className} border-red-400 text-red-500 bg-transparent hover:bg-red-50 focus:ring-red-300 disabled:border-neutral-300 disabled:text-neutral-400`}
  >
    {children}
  </Button>
)

export default BtnDanger
